<nav class="navbar navbar-expand-sm bg-primary navbar-dark mb-2">
    <div class="container-sm">

        <form>
            <div class="input-group input-group-sm ms-0 ps-0 my-0 py-0">
                <input type="text" class="form-control" placeholder="Cerca un vino" [(ngModel)]="searchInput" name="inputSearchWine" style="width: 150px">
                <button type="submit" class="btn btn-info btn-sm text-white" (click)="onSearch()">
                    <span class="bi-search m-0 p-0"></span>
                </button>
            </div>
        </form>
        
        <a class="navbar-toggler shadow-none" type="button" #collapsibleNavbarButton data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
            <span class="navbar-toggler-icon"></span>
        </a>

        <div class="collapse navbar-collapse ms-4 me-4" id="collapsibleNavbar" #collapsibleNavbar>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">VINI</a>
                    <ul class="dropdown-menu">
<!--
                        <li><a class="dropdown-item btn disabled" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">ricerca avanzata</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item btn disabled" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">sotto i riflettori</a></li>
                        <li><hr class="dropdown-divider"></li>
-->
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="winoLibrary/entity/add">aggiungi</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="winoLibrary/entity/modify">modifica</a></li>
                        <span *ngIf="permissionService.isAuthorized(libraryModuleName + '.WineEntityUnderConstructionComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="winoLibrary/entity/underConstruction">in lavorazione</a></li>
                        </span>
                        <span *ngIf="permissionService.isAuthorized(libraryModuleName + '.WineEntityApproveComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="winoLibrary/entity/approve">approva</a></li>
                        </span>
                    </ul>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">POST</a>
                    <ul class="dropdown-menu">
                        <!-- <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.PostCreateComponent')"> -->
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="createPost()">nuovo</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <!-- </span> -->
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="instagramMediaList()">Su Instagram</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="postsList()">elenco</a></li>
                        <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.PostApproveComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="postsApproveList()">approva</a></li>
                        </span>
                        <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.ArticleAllComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn disabled" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">tutti</a></li>
                        </span>
                    </ul>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">ARTICOLI</a>
                    <ul class="dropdown-menu">
                        <!-- <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.ArticleCreateComponent')"> -->
                            <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="createArticle()">nuovo</a></li>
                            <li><hr class="dropdown-divider"></li>
                        <!-- </span> -->
                        <li><a class="dropdown-item btn disabled" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">ricerca</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="articlesList()">elenco</a></li>
                        <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.ArticleApproveComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn text-primary" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="articlesApproveList()">approva</a></li>
                        </span>
                        <span *ngIf="permissionService.isAuthorized(publishingModuleName + '.ArticleAllComponent')">
                            <li><hr class="dropdown-divider"></li>
                            <li><a class="dropdown-item btn disabled" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">tutti</a></li>
                        </span>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>